<template>
  <div id="qrcode" v-if="!resetting" style="position:relative; z-index:190;">
    <md-toolbar class="listBar">

      <md-button @click="goBack()" class="md-icon-button">
        <md-icon>close</md-icon>
      </md-button>

      <h2 class="md-title">{{ pageTitle }}</h2>
    </md-toolbar>

    <md-list v-if="endQR" style="height:100vh !important;">
      <md-list-item>
        <div style="text-align:center; margin:auto; padding-top: 98px;">
          <span class="md-headline">{{ sectorDetails.name }}</span><br>
          <span class="md-title">{{ active.routeName }}</span>
        </div>
      </md-list-item>

      <div style="text-align:center; margin-top:70px; margin-bottom:20px;">
        <md-spinner md-indeterminate :md-size="90" :md-stroke="1.8"></md-spinner>
      </div>

      <md-list-item>
        <div style="text-align:center; margin:auto;">
          <span class="md-subheading" style="position:relative; text-align:center; margin:auto;">Route wird geladen</span>
        </div>
      </md-list-item>

    </md-list>

  </div>
</template>

<script>

import { eventBus } from '../../main'
import { mapState } from 'vuex'
import { mapMutations } from 'vuex'

export default {
  name: 'qrcode',
  data () {
    return {
      pageTitle: 'tendu',
      resetting: false,
      tempSector:'',
      tempRoute:'',
      qrClimbo:'',
      endQR: true,
      validMail: '',
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.endQR = true
    })
  },

  beforeRouteLeave (to, from, next) {
    this.endQR = false
    next()
  },

  created () {
    this.loadEntryLink()

    var qrSector = (window.location.hash.split('/')[2]).toString()
    var qrRoute = window.location.hash.split('/')[3]

    this.tempSector = qrSector
    this.tempRoute = qrRoute
    this.setSector(qrSector)

    // Local testing var link = process.env.BACKEND_URL + '/climbo-backend/v1/sector/' + this.sectorId
    var link = 'climbo-backend/v1/sector/' + this.sectorId
    this.qrClimbo = 'climbo-backend/v1/sector/' + qrSector + '/route/'+ qrRoute + '/qr'
    this.$store.dispatch('getSector', link)

    var detLink = link + '/route/' + this.tempRoute
    this.$http.get(detLink)
    .then(function (response) {
      this.activeDetails = response.data
      this.changeActive(this.activeDetails)
      setTimeout(() => {
        this.endQR = false
        if(this.validUser.hash) {
          this.$store.dispatch('getRouteStatements', this.active.links.route)
          this.$store.dispatch('getRatingStatement', this.active.links.ratingStatement)
          this.gettingProjects()
          this.$router.push('/RouteClimbed')
          this.changePageLoading(false)
        } else {
          var slide= (this.active.gradeNo * 3).toFixed(0)
          this.changeSlideRange(slide)
          this.$router.push('/GuestRating')
          this.changePageLoading(false)

        }
        this.changeQRcode(true)
        this.changeMarker()
        this.sreset ()
      }, 2000)
    },(response) => {
      var status = response.status
      if (status = '500') {
        console.log('error', response.status, 'the route is invalid')
        setTimeout(() => {
          this.goHome()
        }, 2000)
      }
    })
  },

  computed: {
    ...mapState([
      'validUser',
      'pageLoading',
      'noOfLoading',
      'isFilter',
      'isSidebar',
      'sectorDetails',
      'active',
      'isListLoading',
      'storeList',
      'changeSector',
      'userPrivileges',
      'marker',
      'listTemp',
      'projectsId',
      'projectRoutes',
      'isQRcode'
    ]),

    sectorId () {
      return this.$store.state.sectorDetails.id
    },

    rating () {
      return this.$store.state.active.rating.value
    },
  },

  methods: {
    ...mapMutations([
      'setSector',
      'changePreviewSector',
      'changeActive',
      'changeMarker',
      'changeProjects',
      'changeProjectsId',
      'changeTag',
      'changeSlideRange',
      'changeQRcode',
      'changePageLoading'
    ]),

    goBack () {
      this.$router.go(-1)
    },

    goHome () {
      this.$router.push('/')
    },

    sreset () {
      this.resetting = true
      setTimeout(() => {
        this.resetting = false }, 100)
    },

    loadEntryLink () {
      var userEntry = 'climbo-backend/v1/entrypoint'
      this.$http.get(userEntry)
      .then(function (response) {
      if (!response.data.links.user) {
        // console.log('logout error')
      } else {
        this.entryLink = response.data.links.user
        this.$http.get(this.entryLink)
        .then(function (response) {
          // console.log('success')
          // this.userPrivileges = response.data
          this.$store.state.userPrivileges = response.data
          if (response.data.sectors[0]) {
            this.sectorAdmin = true
            // console.log('the user is an administrator')
          } else {
            this.sectorAdmin = false
            // console.log('the user is a tendu user')
          }
          this.isLogin = true
          this.$store.state.validUser.hash = response.data.userName
          this.validMail = response.data.email
          eventBus.$emit('loginStatus', this.isLogin, this.validMail, this.sectorAdmin)
        }, response => {
          // error callback
        })
      }
    }, response => {
      // console.log('not success')
    })
  },

    getTag () {
      if (this.projectsId.includes(this.active.id)) {
        this.changeTag(true)
      } else {
        this.changeTag(false)
      }
    },

    gettingProjects () {
      if (this.validUser.hash) {
        var projectLink = this.userPrivileges.links.projectRoutes
        this.$http.get(projectLink)
        .then(function (response) {
          // this.isListLoading = true
          this.changeProjects(response.data.projectRoutes)
          this.changeProjectsId(response.data.projectRoutes.map(a => a.id))
          this.getTag()

        }, response => {
          // console.log('error')
          })

        } else {
          // console.log('User is not login')
        }
      },
    }
  }

</script>

<style>

</style>
